import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BoardResponseModel } from 'src/app/model/BoardResponseModel';
import { DashboardResponseModel } from 'src/app/model/DashboardResponseModel';
import { InvoiceDetailsResponseModel } from 'src/app/model/InvoiceDetailsResponseModel';
import { InvoiceTrackingResponseModel } from 'src/app/model/InvoiceTrackingResponseModel';
import { Page } from 'src/app/model/Page';
import { TenementExchangeModel } from 'src/app/model/TenementExchangeModel';
import { ApiUrls } from 'src/app/services/ApiUrls';
import { MasterService } from 'src/app/services/master.service';
import { InvoiceModal } from '../invoice-modal/invoice-modal';
import { InvoiceStageModel } from 'src/app/model/InvoiceStageModel';
import { ViewPdfComponent } from '../../view-pdf/view-pdf.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { invoiceSettlementModal } from '../invoice-settlement/invoice-settlement';


@Component({
  selector: 'app-secure-invoice-tracking',
  templateUrl: './generated-invoice-list.component.html',
  styleUrls: ['./generated-invoice-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GeneratedInvoiceFormComponenet implements OnInit {
  page: Page<InvoiceStageModel>;
  dataSource: MatTableDataSource<InvoiceStageModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  filterForm1: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  boardList: {[key:number]:string};

  public lotteryList: {[key:number]:string};

  public schemeList: {[key:number]:string};
  isSubmitDisabled: boolean = false;

  stageValue: number;
  isLoadingAfterSave = false;
  fromDate: string;
  toDate: string;
  filteredData: any;
  startDate:any;
  endDate:any;
  [x: string]: any;
  selectedFile: File;
  orderDocumentFile: string | ArrayBuffer;
  orderDocumentFileFOrView: string | ArrayBuffer;
  orderDocument: string;
  orderFile: string;
  finalStartDate: string;
  finalEndDate: string;

  boardKey: number;
  selectAllChecked: boolean = false;
  lotteryKey: number;
  data: InvoiceDetailsResponseModel;
  key: number;
  applicationId: number;
  stage_no: number;
  invoiceNo: string;
  tenementId: number;
  invoiceStatus: string;
  // selectedElement: InvoiceTrackingResponseModel | null = null;
  selectedElements: InvoiceDetailsResponseModel[] = [];

  // selectedElement: InvoiceTrackingResponseModel | null = null;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  displayedColumns: string[] = [
    "id",
    "invoiceNo",
    "invoiceGenerateDate",
    "invoiceStatus",
    "action"
  ];
  count: any;
  formGroup: any;
  dialogRef: any;


  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private modalCtrl: ModalController,
    //private router: Router,
    private http: HttpClient,
    private datePipe: DatePipe, 
    private _snackBar: MatSnackBar) {
      const currentDate = new Date();
    const tomorrow = new Date(currentDate);
    tomorrow.setDate(tomorrow.getDate() );
    this.tomorrowDate = this.datePipe.transform(tomorrow, "yyyy-MM-dd");
     }

  ngOnInit(): void {
    this.onLoad();

    this.filterForm = new FormGroup({
      file2: new FormControl(null, [Validators.required]),

    });

    this.filterForm1 = new FormGroup({ 
      invoiceNoFilter: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      startDate: new FormControl(null),
      endDate: new FormControl(null)
    });

   

  }


  onLoad() {

    const filterInput = this.filterForm1.value.invoiceNoFilter;
    const startDate1 = this.filterForm1.value.startDate;
    const endDate1 = this.filterForm1.value.endDate;
    let invoiceNoFilter = null;
    let startDate = null;
    let endDate = null;
    let invoiceStatusFilter = null;
  
    console.log('+++++++++++++filterInput',filterInput);
    if (filterInput) {
      if (isNaN(filterInput)) {
        invoiceNoFilter = filterInput;
      } else {
        invoiceStatusFilter = filterInput;
      }
    }
    if(startDate1){
     startDate = this.datePipe.transform(startDate1, "dd-MM-yyyy");
    endDate = this.datePipe.transform(endDate1, "dd-MM-yyyy");
    }



    this.masterService.getInvoiceNumberDetails(this.currentPage, this.pageSize, invoiceNoFilter, invoiceStatusFilter, startDate, endDate)
      .subscribe((data) => {
        console.log(data);
        this.isLoading = false;
        this.page = data;
        this.dataSource = new MatTableDataSource(this.page.content);
        console.log("dataSource >>>> ", this.dataSource);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = this.page.totalElements;
        });
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
      });
      
  }
  
  onSearch() {
    const startDate = this.filterForm1.get('startDate').value;
    const endDate = this.filterForm1.get('endDate').value;

    this.startDate = this.datePipe.transform(startDate, "dd-MM-yyyy");
    this.endDate = this.datePipe.transform(endDate, "dd-MM-yyyy");
    console.log('startDate++++++++++++++++++',startDate);
    console.log('endDate++++++++++++++++++',endDate);

    // Check if either startDate or endDate is not null
    if ((startDate && !endDate) || (!startDate && endDate)) {
        this._snackBar.open("Please select both Start Date and End Date", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
        });
        return;
    }

    this.isLoading = true;
    this.onLoad();
}


  
  resetFilter() {
    this.filterForm1.controls["invoiceNoFilter"].setValue(null);
    this.filterForm1.controls["startDate"].setValue(null);
    this.filterForm1.controls["endDate"].setValue(null);

    //this.filterForm1.reset();
    this.onLoad();
  }
  
  validateOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }

  cancelInvoice(invoiceNo: string, invoiceStatus:string){
    if(confirm("Do you want to delete record?")) {
      // this.invoiceNo=invoiceNo;
     this.masterService.cancelInvoice(invoiceNo, invoiceStatus).subscribe((data:any)=>{
       if(data.status === 'SUCCESS') {
         this.masterService.successToast("Invoice has been cancelled");
         this.onLoad();
       }
       else {
         this.masterService.errorToast(data.errorMessage);
       }
     });
    }

 }

 showInvoiceReceipt(invoiceNo:string) {
  this.isLoading = true;
  this.masterService.downloadInvoiceReceipt(invoiceNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
         base64: data,
          documentName: "Invoice Receipt",
          fileName: this.invoiceNo+"_INVOICE_RECEIPT.pdf"
        }
      });
      modal.present();
    }
    else {
      this.masterService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.masterService.errorToast("Unable to fetch POL");
  });
}

  async invoiceUpload() {
    if (!this.validateOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 10 * 1000,
      });
    }
    
      // new API to update to settle invoice
      this.masterService
        .saveSettledInvoice({
          invoiceNo: this.invoiceNo,
          orderFile: this.orderFile,
          orderDocumentFile: this.orderDocumentFile,
          receivedAmount: this.receivedAmount,
          deductionAmount: this.deductionAmount,
          gstAmount: this.gstAmount,
          approve: "APPROVED",
        })
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
          this.onLoad();
          this._snackBar.open("Invoice Settled", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
        });
  }

  async openModal(invoiceNo) {
    const modal = await this.modalCtrl.create({
            component: invoiceSettlementModal,
            cssClass: "master-modal-lg",
            componentProps: {
              toApplicantData: this.selectedElements,
              invoiceNo
            },
          });
          await modal.present();
          this.isSubmitDisabled = false;
          const { data } = await modal.onWillDismiss();
          console.log("Data---->",data)

    //      if (data === "submit") {
            this.isLoadingAfterSave = true;
            console.log("Try to load again");
            this.onLoad();
            
    //      }
  }

  updateSubmitButtonStatus() {
    this.isSubmitDisabled = this.selectedElements.length === 0;
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }
  
  

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  showObj(o1: any, o2: any) {    
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }


async errorToast(errorMessage: string, dur?: number) {
  await this._snackBar.open(errorMessage, "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "error-toast",
    duration: dur ? dur : 3 * 1000,
  });
}
async successToast() {
  await this._snackBar.open("Invoice Details saved successfully.", "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "success-toast",
    duration: 3 * 1000,
  });
}

}
